<template>
	<div class="card-wrapper md:grid space-y-4 md:space-y-0 md:gap-y-8 md:gap-x-12 md:grid-cols-2">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'CardWrapper',
};
</script>

<style>
@media only screen and (min-width: 769px) {
	.card-wrapper > *:nth-child(4n),
	.card-wrapper > *:nth-child(4n + 1) {
		@apply bg-black;
		--bg-opacity: 0.04;
	}

	.card-wrapper > *:nth-child(4n - 1),
	.card-wrapper > *:nth-child(4n + 2) {
		@apply bg-gray-200;
	}
}

@media only screen and (max-width: 768px) {
	.card-wrapper > *:nth-child(odd) {
		@apply bg-black;
		--bg-opacity: 0.04;
	}

	.card-wrapper > *:nth-child(even) {
		@apply bg-gray-200;
	}
}
</style>
